import { Box, Grid, Skeleton } from '@mui/material';

function RecentHighlightsSkelton() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mb: 2,
      }}
    >
      <Grid container>
        {[1, 2, 3, 4].map((item, index) => (
          <Grid
            item
            xs={6}
            key={index}
            mt={2}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <Skeleton variant="circular" width={120} height={120} />
          </Grid>
        ))}
      </Grid>
      <Skeleton variant="text" width="90%" height={20} sx={{ mt: 2 }} />
      <Skeleton variant="text" width="90%" height={80} />
      <Skeleton variant="text" width="90%" height={20} />
      <Skeleton variant="text" width="90%" height={20} sx={{ mt: 2 }} />
      <Skeleton variant="text" width="90%" height={80} />
      <Skeleton variant="text" width="90%" height={20} />
    </Box>
  );
}

export default RecentHighlightsSkelton;
